import { ChangeEventHandler, FC } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import HeaderDocumentName from 'components/EditorHeader/HeaderDocumentName';
import SetSigner from 'components/SignNow/SelectSignersMenu';
import { EMPTY_DOCUMENT_TITLE_ERROR } from 'constants/signNow';
import { updateSignNowDocument } from 'store/actions/signNow';
import { RootStateType } from 'store/reducers';
import { ISetSignersAndDocumentTitleHeader } from 'types/signNow/base';
import { ISignNowDocument } from 'types/signNow/store';

import 'scss/components/SignNow/_setSigner.scss';

const SetSignersAndDocumentTitleHeader: FC<ISetSignersAndDocumentTitleHeader> = ({
  documentKey,
}) => {
  const dispatch = useDispatch();
  const documents: ISignNowDocument[] = useSelector((state: RootStateType) => state.signNow.documents);
  const currentDocument = documents.find((document) => document.fileKey === documentKey);

  const onChangeDocumentTitle: ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    dispatch(updateSignNowDocument({
      title: target.value,
      isError: !target.value,
      fileKey: documentKey,
    }));
  };

  return (
    <div className="set-signers-header">
      <SetSigner />
      <div className="d-flex flex-column align-items-center p-3">
        <HeaderDocumentName
          documentName={currentDocument?.title ?? ''}
          onChangeDocumentName={onChangeDocumentTitle}
          errorText={currentDocument?.isError ? EMPTY_DOCUMENT_TITLE_ERROR : ''}
        />
      </div>
    </div>
  );
};

export default SetSignersAndDocumentTitleHeader;